import {h, Component} from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import {StylingConfigType} from './configurator'
import Button from '../../control-components/ui-components/Button'

interface Props {
  defaultStyling: StylingConfigType,
  updatedStyling: StylingConfigType,
  onUpdate: (config: StylingConfigType) => void
}

interface State {}

export default class Fonts extends Component<Props, State> {

  updateStyling (key: string, value: string) {
    this.props.onUpdate({ ...this.props.updatedStyling, ...{ [key]: value } })
  }

  render ({defaultStyling, updatedStyling, onUpdate}: Props) {
    return <div class='box__pad'>
      <ul className='theme-configuration_colors-list'>
        <li className='theme-configuration_colors-list-item body-font'>
          <strong>Body font</strong>
          <p>Define the body font used for paragraphs</p>
          <InputGroup value={updatedStyling['config--main-font-base-stack'] || ''} onKeyUp={(e: {target: HTMLInputElement}) => this.updateStyling('config--main-font-base-stack', e.target.value)} />
        </li>

        <li className='theme-configuration_colors-list-item heading-font'>
          <strong>Heading font</strong>
          <p>Define the heading font used for headers and titles</p>
          <InputGroup value={updatedStyling['config--main-font-secondary'] || ''} onKeyUp={(e: {target: HTMLInputElement}) => this.updateStyling('config--main-font-secondary', e.target.value)} />
        </li>

        <li className='theme-configuration_colors-list-item button-font'>
          <strong>Button font</strong>
          <p>Define the button font used for buttons</p>
          <InputGroup value={updatedStyling['config--main-button-base-font-family'] || ''} onKeyUp={(e: {target: HTMLInputElement}) => this.updateStyling('config--main-button-base-font-family', e.target.value)} />
        </li>
      </ul>

      <Button warning onClick={() => onUpdate(defaultStyling)}>
        Reset to defaults
      </Button>
    </div>
  }
}
